module.exports = __webpack_public_path__ + "ff67187ce97c4fcc94de26b1dd8484ed.svg";